import { sql } from 'drizzle-orm';
import {
  doublePrecision,
  foreignKey,
  index,
  integer,
  pgEnum,
  pgTable,
  uuid,
  varchar,
} from 'drizzle-orm/pg-core';
import { driver } from '@trashlab/api/src/domains/driver/schemas/driver';
import {
  defaultFields,
  defaultHistoryFields,
} from '@trashlab/api/drizzle/default';

export const vehicle_status = pgEnum('vehicle_status', ['ACTIVE', 'INACTIVE']);

export const vehicles = pgTable(
  'vehicles',
  {
    ...defaultFields.fieldsWithTenantId(),
    license: varchar('license', { length: 255 }).notNull(),
    name: varchar('name', { length: 255 }).notNull(),
    driverId: uuid('driverId'),
    status: vehicle_status('status').default('ACTIVE').notNull(),
    lastModifiedBy: uuid('lastModifiedBy'),
    createdBy: uuid('createdBy'),
    legacySystemId: varchar('legacySystemId', { length: 255 }),
    vin: varchar('vin', { length: 255 }),
    year: integer('year'),
    make: varchar('make', { length: 255 }),
    model: varchar('model', { length: 255 }),
    defaultTareWeight: doublePrecision('defaultTareWeight'),
    defaultTareWeightUnit: varchar('defaultTareWeightUnit', { length: 10 }),
  },
  (table) => {
    return {
      createdAtTs_idx: index('vehicles_createdAtTs_idx').on(table.createdAtTs),
      tenantId_idx: index('vehicles_tenantId_idx').on(table.tenantId),
      tenant_id_active_cursor_idx: index('vehicles_tenant_id_active_cursor_idx')
        .on(table.tenantId, table.id)
        .where(sql`${table.archivedAtTs} IS NULL`),
      updatedAtTs_idx: index('vehicles_updatedAtTs_idx').on(table.updatedAtTs),
      updatedAtTs_idx1: index('vehicles_updatedAtTs_idx1').on(
        table.updatedAtTs.desc(),
      ),
      versionNumber_idx: index('vehicles_versionNumber_idx').on(
        table.versionNumber,
      ),
      driverId_idx: index('vehicles_driverId_idx').on(table.driverId),
      name_trgm_idx: index('vehicles_name_trgm_idx').using(
        'gin',
        sql`${table.name} public.gin_trgm_ops`,
      ),
      license_trgm_idx: index('vehicles_license_trgm_idx').using(
        'gin',
        sql`${table.license} public.gin_trgm_ops`,
      ),

      //foreign keys
      vehicles_driverId_fkey: foreignKey({
        columns: [table.driverId],
        foreignColumns: [driver.id],
        name: 'vehicles_driverId_fkey',
      }),
    };
  },
);

export const vehicles_history = pgTable('vehicles_history', {
  ...defaultHistoryFields.historyFieldsWithTenantId(),
  license: varchar('license', { length: 255 }),
  name: varchar('name', { length: 255 }),
  driverId: uuid('driverId'),
  status: vehicle_status('status'),
  lastModifiedBy: uuid('lastModifiedBy'),
  createdBy: uuid('createdBy'),
  legacySystemId: varchar('legacySystemId', { length: 255 }),
  vin: varchar('vin', { length: 255 }),
  year: integer('year'),
  make: varchar('make', { length: 255 }),
  model: varchar('model', { length: 255 }),
  defaultTareWeight: doublePrecision('defaultTareWeight'),
  defaultTareWeightUnit: varchar('defaultTareWeightUnit', { length: 10 }),
});
